export default function() {


  return {
    default: ['-1'],
    isRemoteOptions: 0,
    allowCancel: true,
    multiple: true,
    any: { id: '-1', name: { 'en-US': 'Any', 'zh-CN': '任意' } }
  }

}
